import {
  CIRCLE_WALLETS_QUERY,
  USDC_WALLET_QUERY,
  EURC_WALLET_QUERY,
  PROTECTED,
} from '@services/permissions'

import type { Section } from '../types'

/**
 * Custody Circle Wallet Currency.
 */
export const custodyCircleWalletUSDC: Section = {
  label: 'common:activity',
  route: '/custody/circle-wallet/USDC',
  permissions: USDC_WALLET_QUERY,
  segment: {
    page: 'Circle Wallet Detail Page',
  },
}

export const custodyCircleWalletEURC: Section = {
  label: 'common:activity',
  route: '/custody/circle-wallet/EURC',
  permissions: EURC_WALLET_QUERY,
  segment: {
    page: 'Circle Wallet Detail Page',
  },
}

export const custodyCircleWalletCurrency: Section = {
  label: 'common:activity',
  route: '/custody/circle-wallet/[currency]',
  permissions: PROTECTED,
  matchRoute: [custodyCircleWalletUSDC.route, custodyCircleWalletEURC.route],
  segment: {
    page: 'Circle Wallet Detail Page',
  },
}

/**
 * Custody Circle Wallet Currency Policy.
 */
export const custodyCircleWalletPolicyUSDC: Section = {
  label: 'layout:page.circleWallet.policy.title',
  route: '/custody/circle-wallet/USDC/policy',
  permissions: USDC_WALLET_QUERY,
  segment: {
    page: 'Circle Wallet Policy Page',
  },
}

export const custodyCircleWalletPolicyEURC: Section = {
  label: 'layout:page.circleWallet.policy.title',
  route: '/custody/circle-wallet/EURC/policy',
  permissions: EURC_WALLET_QUERY,
  segment: {
    page: 'Circle Wallet Policy Page',
  },
}

export const custodyCircleWalletPolicyCurrency: Section = {
  label: 'layout:page.circleWallet.policy.title',
  route: '/custody/circle-wallet/[currency]/policy',
  permissions: CIRCLE_WALLETS_QUERY,
  matchRoute: [
    custodyCircleWalletPolicyUSDC.route,
    custodyCircleWalletPolicyEURC.route,
  ],
  segment: {
    page: 'Circle Wallet Policy Page',
  },
}

/**
 * Custody Circle Wallet Currency Transaction Detail.
 */
export const custodyCircleWalletTransactionDetailUSDC: Section = {
  label: 'layout:page.circleWallet.pendingTransactionApprovalDetail.title',
  route: '/custody/circle-wallet/USDC/transaction/[id]',
  permissions: USDC_WALLET_QUERY,
  segment: {
    page: 'Circle Wallet Transaction Approval Detail Page',
  },
}
export const custodyCircleWalletTransactionDetailEURC: Section = {
  label: 'layout:page.circleWallet.pendingTransactionApprovalDetail.title',
  route: '/custody/circle-wallet/EURC/transaction/[id]',
  permissions: EURC_WALLET_QUERY,
  segment: {
    page: 'Circle Wallet Transaction Approval Detail Page',
  },
}

export const custodyCircleWalletTransactionDetailCurrency: Section = {
  label: 'layout:page.circleWallet.pendingTransactionApprovalDetail.title',
  route: '/custody/circle-wallet/[currency]/transaction/[id]',
  permissions: CIRCLE_WALLETS_QUERY,
  matchRoute: [
    custodyCircleWalletTransactionDetailUSDC.route,
    custodyCircleWalletTransactionDetailEURC.route,
  ],
  segment: {
    page: 'Circle Wallet Transaction Approval Detail Page',
  },
}

export const custodySection: Section = {
  icon: 'HomeOutline',
  label: 'layout:page.custody.title',
  route: '/',
  permissions: PROTECTED,
  pages: [
    custodyCircleWalletUSDC,
    custodyCircleWalletEURC,
    custodyCircleWalletCurrency,
    custodyCircleWalletPolicyUSDC,
    custodyCircleWalletPolicyEURC,
    custodyCircleWalletPolicyCurrency,
    custodyCircleWalletTransactionDetailUSDC,
    custodyCircleWalletTransactionDetailEURC,
    custodyCircleWalletTransactionDetailCurrency,
  ],
  segment: {
    page: 'home',
  },
}
